export default __webpack_public_path__ + "static/media/ParentsVideo22.45f78376.png";